import { handleKeyDown, isMobile } from "../../utils/utils";


type UploadDocumentButtonProps = {
    onClick: () => void;
    };

export default function UploadDocumentButton({onClick}: UploadDocumentButtonProps) { 
    return(
        <div className='p-x-md file-upload-mobile' onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)} style={{borderColor: "#4D4D4D"}}>
        <div className='form-label'>
          <i className='icon-telechargement-2 fz-xl' />
          <p className="text fw-medium">
            Téléchargez vos fichiers
          </p>
          <div>
            <p className="fz-xs bleu">Sélectionnez un/des fichier(s) depuis votre {isMobile() ? "smartphone" : "ordinateur"}</p>
          </div>
         
          </div>
      </div>
    )
}